<script setup lang="ts">
import ValidationErrors from '@/components/Common/ValidationErrors';
import { reactive, watch, ref } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  operationOfficeName: string;
  operationOfficeNameKana: string;
  errors: { operation_office_name: string; operation_office_name_kana: string };
  windowInnerWidth: number;
}>();
const emit = defineEmits(['inputValue']);
const name = ref('');
const kana = ref('');
const data = reactive({
  operation_office_name: '',
  operation_office_name_kana: '',
});

const unwatchName = watch(
  () => props.operationOfficeName,
  (propsOfficeName) => {
    name.value = propsOfficeName;
    unwatchName();
  }
);
const unwatchKana = watch(
  () => props.operationOfficeNameKana,
  (propsOfficeNameKana) => {
    kana.value = propsOfficeNameKana;
    unwatchKana();
  }
);

watch(name, () => {
  data.operation_office_name = name.value;
  emit('inputValue', data);
});
watch(kana, () => {
  data.operation_office_name_kana = kana.value;
  emit('inputValue', data);
});
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4">
        {{ i18n.global.t('pages.operationOffices.operationOfficeName') }}<span style="color: red">✴︎</span>
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <ValidationErrors :messages="errors?.operation_office_name">
        <v-text-field
          v-model="name"
          maxlength="255"
          :error="errors?.operation_office_name?.length ?? 0 > 0"
        />
      </ValidationErrors>
    </v-col>
  </v-row>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4">
        {{ i18n.global.t('pages.operationOffices.form.operationOfficeNameKana') }}<span style="color: red">✴︎</span>
      </h6>
    </v-col>
    <v-col :cols="windowInnerWidth > 800 ? 10 : 9">
      <ValidationErrors :messages="errors?.operation_office_name_kana">
        <v-text-field
          v-model="kana"
          maxlength="255"
          :error="errors?.operation_office_name_kana?.length ?? 0 > 0"
        />
      </ValidationErrors>
    </v-col>
  </v-row>
</template>
